import FAPlane from 'react-icons/lib/fa/plane';
import FAChevronRight from 'react-icons/lib/fa/chevron-right';
import FAChevronLeft from 'react-icons/lib/fa/chevron-left';
// import FABank from 'react-icons/lib/fa/bank';
import FAInfo from 'react-icons/lib/fa/info-circle';
import FASquare from 'react-icons/lib/fa/square-o';
import FACalendar from 'react-icons/lib/fa/calendar';
import FACheckSquare from 'react-icons/lib/fa/check-square-o';
import FAExternalLink from 'react-icons/lib/fa/external-link';
// import MDNotInterested from 'react-icons/lib/md/not-interested';
// import MDFave from 'react-icons/lib/md/star-border';
// import MDFilterList from 'react-icons/lib/md/filter-list';
import MDSearch from 'react-icons/lib/md/search';
import MDSort from 'react-icons/lib/md/sort';
// import MDLocationCity from 'react-icons/lib/md/location-city';
// import palmSvg from './svgs/categories/palm.svg';
// import palmPinkSvg from './svgs/categories/palm-pink.svg';
// import palmWhiteSvg from './svgs/categories/palm-white.svg';
import sunny from './svgs/weather/Sunny.svg';
import partlyCloudy from './svgs/weather/PartlyCloudyDay.svg';
import lightRain from './svgs/weather/OccLightRain.svg';
import rainAndSun from './svgs/weather/IsoRainSwrsDay.svg';
import moderateRain from './svgs/weather/ModRain.svg';
import cloudy from './svgs/weather/Cloudy.svg';
import overcast from './svgs/weather/Overcast.svg';
import snow from './svgs/weather/snow.svg';

const scale = [0, '0.3em', '0.8em', '2.1em', '5.5em', '14.4em', '37.7em'];

export default {
  scale,
  colors: {
    white: '#FFF',
    grey: '#A4A4A4',
    // grey: 'rgba(72,72,72,0.5)',
    black: '#484848',
    pink: '#EF0568',
    blue: '#00CEE8'
  },
  icons: {
    chevronRight: FAChevronRight,
    chevronLeft: FAChevronLeft,
    calendar: FACalendar,
    externalLink: FAExternalLink,
    plane: FAPlane,
    info: FAInfo,
    search: MDSearch,
    sort: MDSort,
    checkedOn: FACheckSquare,
    checkedOff: FASquare,
    overcast
  },
  matchWeatherIcon: descr =>
    descr === 'sky is clear'
      ? sunny
      : descr === 'few clouds'
        ? partlyCloudy
        : descr === 'scattered clouds'
          ? cloudy
          : descr === 'broken clouds' || descr === 'overcast clouds'
            ? overcast
            : descr === 'light rain' || descr === 'moderate rain'
              ? rainAndSun
              : descr === 'rain'
                ? lightRain
                : descr.includes(' rain')
                  ? moderateRain
                  : descr.includes('snow') ? snow : ''
};



// WEBPACK FOOTER //
// ./src/theme.js